import React, { FC, ReactNode } from 'react';
import { StyleProps, mc } from '@styles';

interface Props extends StyleProps {
  title?: string;
  children?: ReactNode;
  contentClassName?: string;
}

export const PostSidebarSubsectionContainer: FC<Props> = ({ className, contentClassName, style, title, children }) => (
  <div className={mc('px-8', className)} style={style}>
    {!!title && <h6 className="mb-6 font-bold text-xl leading-6 font-sans mt-0">{title}</h6>}
    <div className={contentClassName}>{children}</div>
  </div>
);

export type PostSidebarSubsectionContainerProps = Props;
export default PostSidebarSubsectionContainer;
